import { render } from "./GDQUtils.vue?vue&type=template&id=b344aaf6"
import script from "./GDQUtils.vue?vue&type=script&lang=js"
export * from "./GDQUtils.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__